module.exports = __webpack_public_path__ + "media/images/vya_logo-ddb3790ea7de34517928c86749c20627.png";